import { useGoalsTranslations } from 'modules/iterableGoals/hooks';
import { formatAsPercent, localize } from 'utils/numberHelpers';
import { DeliveryCount, FlexColumn, SubText } from './Styled';

type DeliveryProp = {
  deliveredCount: number;
  deliveredRate: number;
};

export const Delivery = ({ deliveredCount, deliveredRate }: DeliveryProp) => {
  const { t } = useGoalsTranslations();

  return (
    <FlexColumn>
      <DeliveryCount>
        {t('labels.performantCampaigns.total_sent', {
          deliveredCount: localize(deliveredCount),
        })}
      </DeliveryCount>
      <SubText>
        {t('labels.performantCampaigns.delivered', {
          deliveredRate: formatAsPercent(deliveredRate),
        })}
      </SubText>
    </FlexColumn>
  );
};
